import { createContext, useContext } from 'react';
import { PaginationUpdateEvent } from 'ui/paginationFooter';

export interface ReferencesPaginationState {
  currentPage: number;
  limit: number;
  handlePaginationChange: ({ page, pageSize }: PaginationUpdateEvent) => void;
}

export const ReferencesPaginationContext = createContext<ReferencesPaginationState>({
  currentPage: 1,
  limit: 20,
  handlePaginationChange: () => undefined,
});

export const useReferencePaginationContext = () => useContext(ReferencesPaginationContext);
